import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import { WeightedPricesReportTable } from "./WeightedPricesReportTable";
import { usePageStyles } from "../../../pageStyles";
import { PageComponent } from "../../../../core/navigation/types";
import { PageTitle } from "../../../components/common/PageTitle";
import { WeightedPricesReportFilter } from "./WeightedPricesReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const WeightedPricesReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="exchWeightedPrice" />}
              action={<WeightedPricesReportActions />}
            />
            <Divider />
            <CardContent>
              <WeightedPricesReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const WeightedPricesReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <WeightedPricesReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default WeightedPricesReport;
